import { HostAPIBase } from './HostAPIBase';
export class HostAPIClassic extends HostAPIBase {
}
//# sourceMappingURL=HostAPIClassic.js.map